// Schema Zod validando as vars do Vite (import.meta.env).
// Falha cedo em runtime se uma var crítica estiver ausente.
import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.string().url().default('http://localhost:3000'),
  VITE_WS_URL: z.string().url().default('http://localhost:3000'),
  VITE_DEV: z
    .union([z.literal('true'), z.literal('false'), z.boolean()])
    .transform((v) => v === true || v === 'true')
    .default(false),
  VITE_SENTRY_DSN: z.string().optional().default(''),
  // WhatsApp Embedded Signup (Facebook Login for Business). Valores públicos do app
  // Meta — usados client-side no FB.init/FB.login. Opcionais: ausentes, o botão
  // "Conectar via Facebook" aparece desabilitado com aviso (não quebra o boot).
  VITE_META_APP_ID: z.string().optional().default(''),
  VITE_META_CONFIG_ID: z.string().optional().default(''),
  VITE_META_GRAPH_VERSION: z.string().default('v21.0'),
  // Login com Google. Client ID do OAuth ("Aplicativo da Web") — público por
  // natureza, é ele que o Google recebe do browser. Opcional pelo mesmo motivo do
  // VITE_META_APP_ID: ausente, o botão aparece desabilitado em vez de derrubar o
  // boot do app inteiro por causa de uma tela.
  VITE_GOOGLE_CLIENT_ID: z.string().optional().default(''),
});

const raw = {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_URL: import.meta.env.VITE_WS_URL,
  VITE_DEV: import.meta.env.VITE_DEV,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_META_APP_ID: import.meta.env.VITE_META_APP_ID,
  VITE_META_CONFIG_ID: import.meta.env.VITE_META_CONFIG_ID,
  VITE_META_GRAPH_VERSION: import.meta.env.VITE_META_GRAPH_VERSION,
  VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
};

const parsed = schema.safeParse(raw);

if (!parsed.success) {
  // Em prod, queremos ruído alto — não mascarar config quebrada.
  // eslint-disable-next-line no-console
  console.error('[env] variaveis invalidas:', parsed.error.flatten().fieldErrors);
  throw new Error('Variaveis de ambiente VITE_* invalidas: verifique .env.');
}

export const env = parsed.data;

export type Env = typeof env;
